import { render } from "./delivery_companies_component.vue?vue&type=template&id=650c074d&scoped=true"
import script from "./delivery_companies_component.vue?vue&type=script&lang=js"
export * from "./delivery_companies_component.vue?vue&type=script&lang=js"

import "./delivery_companies_component.vue?vue&type=style&index=0&id=650c074d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650c074d"]])

export default __exports__